import { render, staticRenderFns } from "./custom-table-content.component.vue?vue&type=template&id=3b61838c&"
import script from "./custom-table-content.component.ts?vue&type=script&lang=js&"
export * from "./custom-table-content.component.ts?vue&type=script&lang=js&"
import style0 from "./custom-table-content.component.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports